// Links logic
const dataHref = document.querySelectorAll("button[data-href], span[data-href]");
dataHref.forEach((element) => {
  element.addEventListener("click", () => {
    const url = element.getAttribute("data-href");
    if (!url) return;
    element.hasAttribute("data-href-blank")
      ? window.open(url, "_blank")
      : window.location.href = url;
  });
  element.style.cursor = "pointer";
});
